module.exports = __webpack_public_path__ + "img/mapV2.4b584751.png";